import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
// import { PublicClientApplication } from "@azure/msal-browser";
// import { msalConfig } from "./auth/msalConfig";

import App from "./App";

const baseUrl = "/";
const rootElement = document.getElementById("root");
//const msalInstance = new PublicClientApplication(msalConfig);

// React 18 API
const root = ReactDOM.createRoot(rootElement);
root.render(
  <BrowserRouter basename={baseUrl}>
    {/* <App instance={msalInstance} /> */}
    <App />
  </BrowserRouter>,
);
